import Settings from './components/Settings.vue'

export default [
  {
    path: 'settings',
    alias: '',
    component: Settings,
    name: 'Settings - all',
    meta: {description: 'View and Search all of your settings'}
  }
]



// WEBPACK FOOTER //
// ./src/modules/settings/routes.js